import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSpriteLarge,
  OptionItemSpriteLargeList,
} from '@/pages/Onboarding/components/OptionItemSpriteLarge';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { SETTING_SELECTOR_IMAGES } from '@/pages/Onboarding/options/SettingSelector/SETTING_SELECTOR_OPTIONS';
import { SettingSelectorOptionType } from '@/pages/Onboarding/options/SettingSelector/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenSettingSelector: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'SettingSelector',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const settingSelector = form.watch('setting_selector');

  const handleChange = (option: SettingSelectorOptionType) => {
    form.setValue('setting_selector', option.id);
  };

  const handleNextStep = () => {
    userService.createOrUpdate({
      onboarding_data: {
        settingSelector: form.getValues('setting_selector'),
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />
      <OwnAiTitle>Where does your one night begin?</OwnAiTitle>
      <IonContent>
        <OptionItemSpriteLargeList>
          {SETTING_SELECTOR_IMAGES.map((option: SettingSelectorOptionType) => (
            <OptionItemSpriteLarge
              key={option.id}
              spriteSrc={option.spriteSrc}
              alt={option.title}
              title={option.title}
              isSelected={settingSelector === option.id}
              onClick={() => handleChange(option)}
              TEST_ID={`setting-selector-${option.id}`}
              show={true}
              animate={true}
            />
          ))}
        </OptionItemSpriteLargeList>
      </IonContent>

      <OnboardingFooter
        disabled={!settingSelector}
        onContinue={handleNextStep}
        buttonText="Continue"
      />
    </OnboardingPage>
  );
};
